import { VXETable } from '../v-x-e-table';
import PanelComponent from './src/panel';
import filterHook from './src/hook';
import { dynamicApp } from '../dynamics';
export var VxeModuleFilter = {
    Panel: PanelComponent,
    install: function (app) {
        VXETable.hooks.add('$tableFilter', filterHook);
        app.component(PanelComponent.name, PanelComponent);
    }
};
export var Filter = VxeModuleFilter;
dynamicApp.component(PanelComponent.name, PanelComponent);
export default VxeModuleFilter;
